<template>
  <b-card body-class="py-3" class="card-box card__score-description w-100 mx-auto">
    <b-card-body body-class="p-0">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <span class="font-weight-bold">Overall Passing Criteria</span>
        <base-ellipsis
          v-if="editable"
          ref="dropdown__score-description"
          class="dropdown__score-description"
          :disabled="disabled"
        >
          <b-dropdown-item
            :ref="`button__edit-score-description`"
            class="button__edit-score-description"
            :to="scoreDescriptionPage"
          >
            Edit
          </b-dropdown-item>
        </base-ellipsis>
      </div>

      <base-text-editor-display>
        <span
          ref="text__score-description"
          v-safe-html="scoreDescription"
          class="text__score-description"
        />
      </base-text-editor-display>
    </b-card-body>
  </b-card>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import BaseEllipsis from '@/components/base-components/BaseEllipsis';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';

export default {
  components: {
    BaseEllipsis,
    BaseTextEditorDisplay
  },
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    scoreDescription() {
      return this.learningUnit.score_description;
    },

    scoreDescriptionPage() {
      return {
        name: 'learning-unit/score-description',
        params: {
          learningUnitId: this.learningUnit.id
        },
        query: {
          previousPath: this.$route.fullPath
        }
      };
    }
  }
};
</script>

<style lang="scss">
.text__score-description {
  p {
    margin-bottom: 0;
  }
}

.card__score-description {
  max-width: 910px;
}
</style>
